/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the patient-facing AI assistant chat for this tenant. Off when absent — a tenant without this module gets no assistant room, welcome message, or AI replies.
 * @export
 * @interface CareyChatModule
 */
export interface CareyChatModule {
    /**
     * 
     * @type {boolean}
     * @memberof CareyChatModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the CareyChatModule interface.
 */
export function instanceOfCareyChatModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CareyChatModuleFromJSON(json: any): CareyChatModule {
    return CareyChatModuleFromJSONTyped(json, false);
}

export function CareyChatModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): CareyChatModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function CareyChatModuleToJSON(value?: CareyChatModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

